// removed by extract-text-webpack-plugin
module.exports = {"itemList":"itemList--2UHHE","silverBottom":"silverBottom--3_o4t","hide":"hide--2XfNj"};


/*****************
 ** WEBPACK FOOTER
 ** ./shared-components/SearchBar/components/dropdown.scss
 ** module id = 613
 ** module chunks = 2 17
 **/